import 'bootstrap/js/dist/collapse'
import '@/lib/debug'
import '@/lib/ble'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
//
// import '@/lib/jquery/1.12.4/jquery.min'
// import '@/lib/flot/0.8.3/jquery.flot.min'
// import '@/lib/flot/0.8.3/jquery.flot.time.min'
// import '@/lib/flot/0.8.3/jquery.flot.pie.min'
//
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faThermometerHalf,
  faHeartbeat,
  faChartLine,
  faToggleOn,
  faToggleOff,
  faCalendarAlt,
  faClock,
  faBolt,
  faRedo,
  faTint,
  faWater,
  faStethoscope,
  faLink,
  faUnlink,
  faSpinner,
  faSortDown,
  faClipboardCheck,
  faCogs,
  faChevronLeft,
  faTimes,
  faCheck,
  faExclamation,
  faWrench,
  faChevronDown,
  faChevronUp
} from '@fortawesome/free-solid-svg-icons'
import {
  faHeartRate,
  faTachometer,
  faOilTemp,
  faOilCan,
  faCommentAltExclamation
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faThermometerHalf,
  faHeartbeat,
  faChartLine,
  faToggleOn,
  faToggleOff,
  faHeartRate,
  faTachometer,
  faCalendarAlt,
  faClock,
  faBolt,
  faRedo,
  faTint,
  faWater,
  faOilTemp,
  faOilCan,
  faCommentAltExclamation,
  faStethoscope,
  faLink,
  faUnlink,
  faSpinner,
  faSortDown,
  faClipboardCheck,
  faCogs,
  faChevronLeft,
  faTimes,
  faCheck,
  faExclamation,
  faWrench,
  faChevronDown,
  faChevronUp
)

Vue.component('fa-icon', FontAwesomeIcon)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js